require("tether/dist/js/tether.min")
require("js/public_company/plugins/stellar/jquery.stellar.min")
require("owl.carousel/dist/owl.carousel")
require("js/public_company/plugins/mega-menu") 
require("js/public_company/plugins/retina/retina.min") 
require("packs/public_company/contact.js")
require("js/public_company/plugins/jquery.main.js")
require("revslider/js/jquery.themepunch.tools.min")
require("revslider/js/jquery.themepunch.revolution.min")
require("revslider/js/extensions/revolution.extension.actions.min.js")
require("revslider/js/extensions/revolution.extension.carousel.min")
require("revslider/js/extensions/revolution.extension.kenburn.min")
require("revslider/js/extensions/revolution.extension.layeranimation.min")
require("revslider/js/extensions/revolution.extension.migration.min")
require("revslider/js/extensions/revolution.extension.navigation.min")
require("revslider/js/extensions/revolution.extension.parallax.min")
require("revslider/js/extensions/revolution.extension.slideanims.min")
require("revslider/js/extensions/revolution.extension.video.min")
require("js/public_company/plugins/revolution.js")
import { check_recaptcha } from "./recaptcha"
window.check_recaptcha = check_recaptcha